import { all, call, put, takeLatest } from 'redux-saga/effects'
import configurableTilesApi from '@edulastic/api/src/configurableTiles'
import {
  FETCH_PRODUCT_UPDATES_LINK,
  setProductUpdatesLinkAction,
} from '../reducers/productUpdates'

export const PRODUCT_UPDATES_BANNER_TYPE = 'PRODUCT_UPDATES'

export function* fetchProductUpdatesLinkSaga() {
  try {
    const result = yield call(
      configurableTilesApi.fetchTiles,
      0,
      undefined,
      undefined,
      PRODUCT_UPDATES_BANNER_TYPE
    )
    yield put(
      setProductUpdatesLinkAction({
        url: result?.data?.url || null,
        notifiedAt: result?.data?.notifiedAt || null,
      })
    )
  } catch (e) {
    // Silent by design: no notification; the sidebar falls back to the default URL.
    yield put(setProductUpdatesLinkAction({ url: null, notifiedAt: null }))
  }
}

export default function* watcherSaga() {
  yield all([
    takeLatest(FETCH_PRODUCT_UPDATES_LINK, fetchProductUpdatesLinkSaga),
  ])
}
